









import 'vue-swatches/dist/vue-swatches.css'
import { Component, Vue, Provide, ProvideReactive } from 'vue-property-decorator'
import { Route } from 'vue-router'
import { mapState, mapGetters } from 'vuex'
import { localStore } from '@/_utils/localstore'

import { commonService } from '@/_services'
import { CurrentUser } from '@/_interfaces/CurrentUser'

import { Navbar, Sidebar, Footer } from '@/components/layout'
import FlashMessage from '@/components/common/FlashMessage.vue'

const unitInfoService = commonService('api/v1/me')

@Component({
  components: { Navbar, Sidebar, Footer, FlashMessage },
  computed: {
    ...mapState('common', {
      flashMessages: 'messages',
    }),
    ...mapGetters('common', {
      isReadOnly: 'observerRole',
    }),
  },
})
export default class Layout extends Vue {
  flashMessages!: object

  @Provide('is-observer')
  isReadOnly!: () => boolean

  @ProvideReactive('user')
  get currentUser(): CurrentUser {
    return this.$store.state.authentication.currentUser
  }

  setCurrentUser(resp) {
    this.$store.commit('authentication/LOGIN_SUCCESS', resp)
  }

  get unitLogo(): string {
    if (this.currentUser) {
      return this.currentUser.logo as string
    } else {
      const user = JSON.parse(localStore.getItem('user') as string)
      return (user && user.logo) || ''
    }
  }

  @Provide('logout')
  clickLogout(): void {
    this.$store.dispatch('resetAllModulesState')
    this.$store.dispatch('authentication/logout')
  }

  async beforeRouteEnter(to: Route, from: Route, next) {
    const currentUser = JSON.parse(localStore.getItem('user') as any) as CurrentUser

    if (currentUser && currentUser.operator_name) {
      let resp: any = null
      try {
        resp = await unitInfoService.getAll({
          operator_name: currentUser.operator_name,
        })
      } catch (e) {
        console.error(`Failed get profile: ${e}`)
      }

      if (!resp || !resp.data) {
        return next(vm => {
          vm.clickLogout()
        })
      }

      const unitFeatures = resp.data.manage_features
      const checkHyperRoute = meta => {
        // Unset Feature On/Off
        if (meta.hyperCheck && !unitFeatures.hasOwnProperty(meta.featureName)) {
          return false
        }

        return !unitFeatures[meta.featureName]
      }

      if (to.meta && to.meta.requirePermissionFeature && unitFeatures && checkHyperRoute(to.meta)) {
        return next('/dashboard')
      }

      next(vm => {
        vm.setCurrentUser(resp)
      })
    }
  }
}
